import {InputNumber} from "antd";
import styles from "../../styles/expenses.create.statement.modal.module.css";
import React from "react";


// Компонент ввода суммы


export const AmountInput = ({value, onChange}) => (
    <InputNumber
        size="small"
        className={styles.amountInput}
        min={0}
        step={100}
        value={value}
        onChange={onChange}
        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
        parser={value => value.replace(/\s/g, '')}
    />
);